import { RouteProps } from 'react-router';
import Home from './home';
import UnregisteredFolios from './home/unregistered-folios';
import UnregisteredFoliosSuccess from './home/unregistered-folios-success';
import MakeNCT from './makeNct';
import changeMobileSuccess from './makeNct/ChangeMobile/change-mobile-success';
import Portfolios from './portfolios';
import PortfolioSchemes from './portfolios/portfolio-scheme-details';
import MyProfile from './profile';
import SebiCas from './sebi';
import trackStatus from './trackStatus';
import trackStatusNctType from './trackStatus/track-status-nct-type';
import ViewUnclaimedPayouts from './unclaimedPayout/view-unclaimed-payout';
import OtpVerification from './makeNct/ChangeMobile/otp';
import updateSecurityQuestions from './update-security-questions';
import updateSecurityQuestionsOtp from './update-security-questions-otp';
import UpdateSecurityQuestionsSuccess from './update-security-success';
import ResetPin from './ResetPin';
import UnregisteredOtp from './home/authVerify';
import CRMDashboard from './CRMDashboard';
import MakeCT from './commercial';
import trackStatusTransactionType from './trackStatus/track-status-transaction-type';
import KycStatus from './trackStatus/kycStatus';
import { DepositoryRequest } from './deporeq/DepositoryRequest';
import DepositorySuccess from './deporeq/DepositoryStatus';
import statements from './statements';

export const DashboardRoutes: RouteProps[] = [
    {
        path: `/home`,
        component: Home,
    },
    {
        path: `/portfolio`,
        component: Portfolios,
    },
    {
        path: `/nct`,
        component: MakeNCT,
    },
    {
        path: `/portfolio-scheme-details/:amc`,
        component: PortfolioSchemes,
    },
    {
        path: `/unregistered-folios`,
        component: UnregisteredFolios,
    },
    {
        path: `/unregistered-folios-otp`,
        component: UnregisteredOtp,
    },
    {
        path: `/unregistered-folios-success`,
        component: UnregisteredFoliosSuccess,
    },
    {
        path: `/profile`,
        component: MyProfile,
    },
    {
        path: `/update-security-questions`,
        component: updateSecurityQuestions,
    },
    {
        path: `/update-security-questions-otp`,
        component: updateSecurityQuestionsOtp,
    },
    {
        path: `/update-security-questions-success`,
        component: UpdateSecurityQuestionsSuccess,
    },
    {
        path: '/unclaimed-payout',
        component: ViewUnclaimedPayouts,
    },
    {
        path: '/track',
        component: trackStatus,
    },
    {
        path: '/track-for-nct/:transactionId',
        component: trackStatusNctType,
    },
    {
        path: '/track-for-transaction/:transactionId',
        component: trackStatusTransactionType,
    },
    {
        path: '/sebi-cas',
        component: statements,
    },
    {
        path: '/crm',
        component: CRMDashboard,
    },
    {
        path: '/depreq',
        component: DepositoryRequest,
    },
    {
        path: '/depreq-success',
        component: DepositorySuccess,
    },
    {
        path: `/commercial`,
        component: MakeCT,
    },
    {
        path: `/kyc-status/:id`,
        component: KycStatus
    },
];
